export const path = "/social-media-compao";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "RRSS",
  section: "COMPAO",
  group: null,
  order: 2,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "master-rrss-roundler",
    "master-aluna-rrss",
    "roundler-admin",
    "aluna",
  ],
};
